import {createSelector} from 'reselect';
import {selPersonAllIds, selPersonById, selPersonTemplateId} from 'module/Person/selector/PersonSelector';
import {mapPersonToSelectItem} from 'module/Person/util/PersonSelectUtil';

export const selPersonOptions = createSelector(
	selPersonAllIds,
	selPersonById,
	selPersonTemplateId,
	(persNrsSorted, personsById, templateId) => {
		return persNrsSorted
			.map(persNr => personsById[persNr])
			.flatMap(p => !p ? [] : [mapPersonToSelectItem(p, templateId)])
	},
);